import landingImage from '../../../../assets/landing.png'
import { baseURL } from '../../../../api/url'

export default function RegisterPageBottomSection() {
  const ready = async () => {
    try {
      sessionStorage.clear()
      const url = `${baseURL}/face/register`
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ screen: 'register' }),
      })
      const data = await response.json() as { success: boolean;  status: number; data?: { VerificationUrl: string; BizToken: string }, error?: { code: string } }

      if (data.success) {
        sessionStorage.setItem('registration_started', 'true')
        sessionStorage.setItem('step', '1')
        sessionStorage.setItem('face_index', data?.data?.BizToken || '')
        window.location.href = data?.data?.VerificationUrl || ''
      }
    } catch (error) {
      console.error('Error fetching verification URL:', error)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex items-center justify-center py-6">
        <img src={landingImage} alt="Landing" className="w-[50%]" />
      </div>

      <div className="buttonSectionStyle">
        <button
          type="button"
          onClick={ready}
          className="w-48 rounded-2xl bg-[#5CB891] px-8 py-2 text-white">
          Register
        </button>
      </div>
    </div>
  )
}
